import { SubmissionError } from 'redux-form';
import {
	FIELDS_FOR_VALIDATE,
	TYPES_WITH_DATE_ISSUE_AND_MODES,
	TYPES_WITH_TRAILER,
	TYPES_WITHOUT_OWNERSHIP_INFO,
} from './constants';

export const transformToValidationErrors = errors => {
	return Object.entries(errors).reduce((result, [key, value]) => {
		if (key.includes('modes')) {
			const arr = key.split('.');

			if (!result.modes) {
				result.modes = {};
			}

			result.modes = {
				...result.modes,
				[arr[1]]: {
					modes: `${result.modes[arr[1]] || ''} ${value}`,
				},
			};
		}

		return {
			...result,
			[key]: value[0],
		};
	}, {});
};

const getFieldsForValidate = values => {
	const result = [...FIELDS_FOR_VALIDATE];

	if (TYPES_WITH_DATE_ISSUE_AND_MODES.includes(values.type_id)) {
		result.splice(4, 0, 'type_date_issue');
	}

	if (!TYPES_WITHOUT_OWNERSHIP_INFO.includes(values.ownership_id)) {
		result.push('doc_name', 'doc_number', 'doc_date');
	}

	if (TYPES_WITH_TRAILER.includes(values.type_id)) {
		result.push('trailer');
	}

	return result;
};

export const validate = values => {
	getFieldsForValidate(values).forEach(key => {
		if (!values?.[key]) {
			throw new SubmissionError({ [key]: 'Заполните это поле' });
		}
	});
};
